import { FC } from "react";
import { Route, Switch } from "react-router";

import { RouteWithSubRoutes, IRoute } from "@router";
import Dashboard from "@/pages/client/Dashboard";
import { useTypedSelector } from "@/hooks";
import GradeSetup from "@/pages/client/GradeSetup";

const Routes: FC<{ routes: IRoute[] }> = ({ routes }) => {
  const { user , permissions } = useTypedSelector(state => state.auth);
  console.log("user  : ", user);
  const hasTOMDashboardPermission = permissions?.includes("VIEW_TOM_DASHBOARD");
  console.log("hasJEDashboardPermission : ", hasTOMDashboardPermission);

  return (
    <Switch>
      {routes.map(route => (
        <RouteWithSubRoutes {...route} />
      ))}

      {/* <Route component={Dashboard} /> */}
      {user?.role === "TOM_MASTER_USER" ? (
        <Route component={Dashboard} />
      ) : hasTOMDashboardPermission ? (
        <Route component={Dashboard} />
      ) : (
        <Route component={GradeSetup} />
      )}

    </Switch>
  );
};

export default Routes;
